<div class="header">
  <div>
    <h2>Expense List</h2>
    <p>Manage, track, and monitor all expenses in a structured way.</p>
  </div>
  <button class="add-btn" (click)="toggleCategoryModal()">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Category
  </button>
</div>
<div class="rp-body">

  <!-- Loop through sections -->
  <div *ngFor="let section of sections; let i = index" class="rp-outer">

    <!-- SKELETON -->
    <ng-container *ngIf="showSkeleton">
      <div class="skeleton-table" style="padding: 20px;">
        <div class="skeleton-row header" style="width: 30%;"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row"></div>
      </div>
    </ng-container>

    <!-- REAL CONTENT -->
    <ng-container *ngIf="!showSkeleton">
      <div class="heading-outer">
        <h4 (click)="toggleSection(i)">
          <svg class="mr-2 flip-icon" [class.is-open]="section.isOpen" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline class="arrow-top" points="18 9 12 3 6 9"></polyline>
            <polyline class="arrow-bottom" points="18 15 12 21 6 15"></polyline>
          </svg>
          {{ section.title }}
        </h4>
        <button (click)="openAddSubCategory(i)">Add Sub-Category</button>
      </div>

      <div *ngIf="section.isOpen" class="table-wrapper">
        <table class="mt-4">
          <thead>
            <tr>
              <th>Title</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Attachments</th>
              <th>Status</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of section.expense; let j = index">
              <td>{{ item.title }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.attach }}</td>
              <td>
                <span class="badge" [class.badge-paid]="item.status.toLowerCase() === 'paid'"
                  [class.badge-unpaid]="item.status.toLowerCase() === 'unpaid'">
                  {{ item.status }}
                </span>
              </td>
              <td class="text-right icon-btns">
                <button class="btn-icon" (click)="openEditSubCategory(item, i, j)">
                  <img src="assets/images/editIcon.svg" alt="Edit" />
                </button>
                <button class="btn-icon" (click)="deleteSubCategory(i, j)">
                  <img src="assets/images/trashIcon.svg" alt="Delete" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

  </div>
</div>
<!-- CATEGORY MODAL -->
<app-add-popup *ngIf="showCategoryModal" title="Add New Category"
  subtitle="Use this form to create a new expense category" iconPath="assets/images/addPopup.png"
  (close)="toggleCategoryModal()">
  <form [formGroup]="categoryForm" (ngSubmit)="onSaveCategory()">
    <div class="input-group">
      <label>Category Title*</label>
      <input type="text" formControlName="title" placeholder="Write here" />
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleCategoryModal()">
        Cancel
      </button>

      <button type="submit" class="btn-save" [disabled]="categoryForm.invalid">
        <span> <img src="assets/images/savePopup.svg" alt="" /></span> Save
      </button>
    </div>
  </form>
</app-add-popup>

<!-- SUB CATEGORY MODAL -->
<app-add-popup *ngIf="showSubCategoryModal" [title]="isEditMode ? 'Edit Sub-Category' : 'Add Sub-Category'" [subtitle]="
    isEditMode
      ? 'Use this form to edit existing sub-category'
      : 'Use this form to create a new sub-category'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleSubCategoryModal()">
  <form [formGroup]="subCategoryForm" (ngSubmit)="onSaveSubCategory()">
    <div class="input-group">
      <label>Title*</label>
      <input type="text" formControlName="title" />
    </div>

    <div class="input-group">
      <label>Amount*</label>
      <input type="text" formControlName="amount" />
    </div>

    <div class="row-inputs">
      <div class="input-group">
        <label>Date*</label>
        <input type="date" formControlName="date" />
      </div>

      <div class="input-group">
        <label>Status*</label>
        <div class="select-wrapper">
          <select formControlName="status" class="pill-input">
            <option value="Paid">Paid</option>
            <option value="Unpaid">Unpaid</option>
          </select>
        </div>
      </div>
    </div>
    <div class="upload-section">
      <label>Upload Attachment <span> (Optional)</span></label>
      <div class="drag-drop-box" (click)="fileInput.click()" (dragover)="$event.preventDefault()"
        (drop)="onFileDropped($event)">
        <input #fileInput type="file" hidden (change)="onFileSelected($event)" />
        <img src="assets/images/upload-icon.svg" alt="upload" width="24" />
        <p>Drag & Drop or <span>Choose file</span> to upload</p>
        <p *ngIf="selectedFileName" class="file-name">
          {{ selectedFileName }}
        </p>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleSubCategoryModal()">
        Cancel
      </button>

      <button type="submit" class="btn-save" [disabled]="subCategoryForm.invalid">
        <span> <img src="assets/images/savePopup.svg" alt="" /></span> Save
      </button>
    </div>
  </form>
</app-add-popup>